import api from "@/utils/http";

/**
 功能：
 time: 2026/1/6 18:09
 **/
export function getCertConfig() {
    return api.get('/admin/cert/getSetConfig')
}
/**
 功能：
 time: 2026/1/6 18:09
 **/
export function getCertList(data) {
    return api.post('/admin/cert/getList', data)
}
/**
 功能：
 time: 2025/12/25 16:02
 **/
export function saveCert(data) {
    return api.post('/admin/cert/eSave', data)
}

/**
 功能：
 time: 2026/1/7 09:50
 **/
export function getCertDetail(id) {
    return api.post('/admin/cert/getDetail', {id })
}

/**
 功能：
 time: 2026/1/7 10:04
 **/
export function deleteCert(id) {
    return api.post('/admin/cert/del', {id})
}



